import { render, staticRenderFns } from "./GameSrcToTarget.vue?vue&type=template&id=7812aba7&scoped=true&"
import script from "./GameSrcToTarget.vue?vue&type=script&lang=js&"
export * from "./GameSrcToTarget.vue?vue&type=script&lang=js&"
import style0 from "./GameSrcToTarget.vue?vue&type=style&index=0&id=7812aba7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7812aba7",
  null
  
)

export default component.exports